import { useTranslation } from 'react-i18next';
import type { Mode } from '../../types/agent';
import { SculptMark } from './Header';

/** Empty state (product owner, 2026-09-10, in the manner of the LLM chat apps): the mark and "Welcome, {first name}",
 *  centered in the pane with the composer right below (see ChatPanel). No subtitle, no starter prompts — the mode
 *  is explained by the mode switch of the composer. */
export function Welcome({ firstName }: { firstName: string | null; mode?: Mode }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-3 px-4 text-center animate-pc-in" data-testid="welcome">
      <SculptMark size={64} />
      <div className="text-[22px] font-medium leading-[1.2] tracking-[-0.02em] text-ink">{firstName ? t('welcome.greeting', { name: firstName }) : t('welcome.greetingAnon')}</div>
    </div>
  );
}
